import { render } from "./PrescriptionExamens.vue?vue&type=template&id=34200358&scoped=true"
import script from "./PrescriptionExamens.vue?vue&type=script&lang=js"
export * from "./PrescriptionExamens.vue?vue&type=script&lang=js"

import "./PrescriptionExamens.vue?vue&type=style&index=0&id=34200358&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34200358"]])

export default __exports__